module.exports = __webpack_public_path__ + "img/obs_water_refuge_up.d5065e23.svg";